import gsap from 'gsap';
import tailwindConfig from '../../../tailwind.config';

const tabletScreen = tailwindConfig.theme.screens.lg.replace('px', '')

function isTouchDevice() {
    return window.matchMedia("(pointer: coarse)").matches;
}

function videoPlayButton() {
    const magnificVideos = document.querySelectorAll(".magnific-video");
    const videoPlayButtons = document.querySelectorAll(".video-play-button");

    if (magnificVideos.length > 0 && videoPlayButtons.length > 0) {


		videoPlayButtons.forEach(playButton => {
			// Hide on touch devices and smaller screens.
			if ( isTouchDevice() || window.innerWidth < tabletScreen) {
				playButton.classList.add('hidden');

				return
			}

			const cursorActiveSpace = playButton.parentNode

			let xSetter = gsap.quickSetter(playButton, "x", "px") //apply it to the #id element's x property and append a "px" unit
			let ySetter = gsap.quickSetter(playButton, "y", "px") //apply it to the #id element's x property and append a "px" unit


			// Handles the mouse move
			function handleMouseMove(e) {
				// Check if the mouse is inside the cursorActiveSpace
				const rect = cursorActiveSpace.getBoundingClientRect();
				if ( e.x < rect.left || e.x > rect.right || e.y < rect.top || e.y > rect.bottom || e.target instanceof HTMLAnchorElement ) {
					// Mouse is outside the cursorActiveSpace
					//gsap.to(playButton, { opacity: 0, duration: 0.1 });

					gsap.set(playButton, { position: 'absolute', xPercent: -50, yPercent: -50, top: '50%', left: '50%', opacity: 1 });
					xSetter('0');
					ySetter('0');
				} else {
					// Mouse is inside the cursorActiveSpace and video is not playing, show the cursor
					gsap.set(playButton, { position: 'fixed', xPercent: -50, yPercent: -50, clearProps: "top,left" });

					xSetter(e.x);
					ySetter(e.y);

					gsap.to(playButton, { opacity: 1, duration: 0.1 });
				}
			}

			function handleMouseWheel(e){
				gsap.set(playButton, { position: 'absolute', xPercent: -50, yPercent: -50, top: '50%', left: '50%', opacity: 1 });
				xSetter('0');
				ySetter('0');

				//var rect = cursorActiveSpace.getBoundingClientRect();
				//var mouseX = e.clientX;
				//var mouseY = e.clientY;

				// Check if the mouse pointer is inside the div
				/* if (mouseX >= rect.left && mouseX <= rect.right && mouseY >= rect.top && mouseY <= rect.bottom) {
					// Inside the block
				} else {
					// Outside the block
				} */
			}
			
			// Add the mouse move event listener
			window.addEventListener("mousemove", handleMouseMove);

			// Add scroll listener
			window.addEventListener("wheel", handleMouseWheel);
		});
    }
}

export default videoPlayButton;
